const OBJ_CLASSES = [
  "Contact",
  "ContentPage",
  "Document",
  "EventItem",
  "EventList",
  "Homepage",
  "JobItem",
  "JobList",
  "LandingPage",
  "NewsItem",
  "NewsList",
];

export const getSearchObjects = (translate) => ({
  all: {
    title: translate("SEARCH_PAGE_CATEGORY_ALL"),
    values: OBJ_CLASSES,
  },
  pages: {
    title: translate("SEARCH_PAGE_CATEGORY_PAGES"),
    values: ["ContentPage"],
  },
  news: {
    title: translate("SEARCH_PAGE_CATEGORY_NEWS"),
    values: ["NewsItem", "NewsList"],
  },
  contact: {
    title: translate("SEARCH_PAGE_CATEGORY_CONTACT"),
    values: ["Contact"],
  },
  documents: {
    title: translate("SEARCH_PAGE_CATEGORY_DOCUMENTS"),
    values: ["Document"],
  },
});
